import { useEffect, useState } from 'react';
import { canPromptInstall, isIos, isStandalone, onInstallChange, promptInstall } from '../pwa';

// «Tətbiqi yüklə» (KT-94): Android/Chrome — brauzerin quraşdırma pəncərəsi; iPhone — «Paylaş → Ana ekrana əlavə et» təlimatı.
// Tətbiq kimi açılıbsa (artıq quraşdırılıb) göstərilmir.
export function InstallApp({ className = 'm-link' }: { className?: string }) {
  const [, force] = useState(0);
  const [help, setHelp] = useState(false);

  useEffect(() => onInstallChange(() => force((n) => n + 1)), []);

  if (isStandalone()) return null;
  const ios = isIos();
  if (!ios && !canPromptInstall()) return null;

  const click = () => {
    if (ios) setHelp((v) => !v);
    else void promptInstall();
  };

  return (
    <>
      <button type="button" className={className} onClick={click} aria-expanded={ios ? help : undefined}>
        Tətbiqi yüklə
      </button>
      {help && (
        <p className="m-help" role="note">
          iPhone-da: Safari-də aşağıdakı <strong>Paylaş</strong> düyməsini basın, sonra <strong>«Ana ekrana əlavə et»</strong> seçin. Tətbiq ana ekranda
          ikon kimi görünəcək.
        </p>
      )}
    </>
  );
}
